import React from 'react';
import Loader from './Loader';
const LaunchScreen = () => {
  return (
    <div className="h-screen w-full flex items-center justify-center text-gray-700 bg-gray-200 text-sm">
      <div>
        <div className="mt-2 mr-10"><Loader size="50" /></div>
        <p className="block mt-14 text-center font-bold uppercase">chargement</p>
      </div>
    </div>
  );
}

export default LaunchScreen;
